export const wipeState = () => ({
  type: "RESET_APP",
  payload: [],
});
